import React from "react";

import { bodyTextStyle } from "./bodyTextStyle";

export default ({ node }) => {
  return (
    <div style={bodyTextStyle}>
      {node.node_data.time_units} {node.node_data.time_unit} {node.node_data.time_offset} {node.node_data.wait_until_event}
    </div>
  );
};
